export default {
  SAVE_ONLINE_SUCCESS: 'SAVE_ONLINE_SUCCESS',
  SAVE_ONLINE_ERROR: 'SAVE_ONLINE_ERROR',
  CHANGE_SAVE_STATUS: 'CHANGE_SAVE_STATUS',
  CHANGE_UNDO_REDO_STATUS: 'CHANGE_UNDO_REDO_STATUS',
  CHANGE_UNDO_REDO_STATUS_BEFORE: 'CHANGE_UNDO_REDO_STATUS_BEFORE',
  GRAPH_INIT: 'GRAPH_INIT',
  GRAPH_ROTATE: 'GRAPH_ROTATE',
  GRAPH_SET_CROP: 'GRAPH_SET_CROP',
  GRAPH_SET_CROP_TYPE: 'GRAPH_SET_CROP_TYPE',
  AUTO_POSITION_SELECTED_TIMELINE: 'AUTO_POSITION_SELECTED_TIMELINE',
  SEEK_TIMELINE: 'SEEK_TIMELINE',
  AUTO_EDGE_SCROLL: 'AUTO_EDGE_SCROLL',
  TRIGGER_AUTO_EDGE_SCROLL: 'TRIGGER_AUTO_EDGE_SCROLL',
  PAUSE: 'PAUSE',
  UPDATE_RESOURCE_DOWNLOAD_DATA: 'UPDATE_RESOURCE_DOWNLOAD_DATA',
  UPDATE_WATERMARK: 'UPDATE_WATERMARK',
  SHOW_STOCK_TIP: 'SHOW_STOCK_TIP',
  STOCK_HIDDEN: 'STOCK_HIDDEN',
  UPDATE_TIMELINE: 'UPDATE_TIMELINE',
  UPDATE_CANVAS_SIZE: 'UPDATE_CANVAS_SIZE',
  UPDATE_TIMELINE_HEIGHT: 'UPDATE_TIMELINE_HEIGHT',
  CHANGE_EXPORT_STATUS: 'CHANGE_EXPORT_STATUS',
  INDEXEDDB_FULLED: 'INDEXEDDB_FULLED',
}